import {
  HistoryDetail,
  PostalAddressOption,
  TermsAndConditions,
} from 'scenes/common/flows/policyDetails/types';
import {
  LocalityAddress,
  PostalAddress,
  PolicyHolder,
  YesNoAnswer,
  YesNoDontKnowAnswer,
  PaymentFrequency,
} from 'scenes/common/types';

export enum LandlordPolicySubSection {
  ProperyInGoodCondition = 'Property in good condition',
  PropertyUnderRenovation = 'Property under renovation',
  ReplumbedOrRewired = 'Replumbed or rewired',
  HeritageListed = 'Heritage listed',
  PropertyUnoccupied = 'Property unoccupied',
  PropertyOver5Acres = 'Property over 5 acres',
  PropertyUnrelatedPeople = 'Property unrelated people',
  PersonalPolicyContact = 'Personal policy contact',
  BusinessPolicyContact = 'Business policy contact',
  ContactPhoneNumber = 'Contact phone number',
  ContactEmailAddress = 'Contact email address',
  // eslint-disable-next-line no-shadow
  PostalAddress = 'Postal address',
  BusinessNameAndAbn = 'Business name and ABN',
  AdditionalPolicyHolders = 'Additional policy holders',
  PolicyHolderDeclaration = 'Policy holder declaration',
  Mortgage = 'Mortgage',
}

export interface PolicyDetailsData {
  propertyInGoodCondition: YesNoAnswer;
  heritageListed: YesNoAnswer;
  rewiredOrReplumbed: YesNoDontKnowAnswer;
  propertyUnoccupied: YesNoAnswer;
  propertyRenovationCurrent: YesNoAnswer;
  propertyRenovationFuture?: YesNoAnswer;
  over5Acres: YesNoAnswer;
  propertyOccupancy: YesNoAnswer;
  mortgageProvider: string;
  mortgageProviderOther: string;
  businessName: string;
  abn: string;
  businessContactFirstName: string;
  businessContactLastName: string;
  personalContactFirstName: string;
  personalContactLastName: string;
  addAdditionalPolicyHolder: YesNoAnswer;
  additionalPolicyHolders: PolicyHolder[];
  additionalPolicyHolder?: PolicyHolder;
  contactPhoneNumber: string;
  contactEmailAddress: string;
  postalAddressOption: PostalAddressOption;
  isPostalAddressDifferentManual?: boolean;
  lockedBoxAddress: LocalityAddress;
  postalAddress: PostalAddress;
  historyDetails: HistoryDetail[];
  termsAndCondition: TermsAndConditions;
  preselectedPaymentFrequency: PaymentFrequency;
}
